// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b354c4d2","455":"220461fa"}[chunkId] + ".chunk.js";
};